
namespace GeniuzPOS.Points {

    @Serenity.Decorators.registerClass()
    export class PrPointRedeemItemDialog extends Serenity.EntityDialog<PrPointRedeemItemRow, any> {
        protected getFormKey() { return PrPointRedeemItemForm.formKey; }
        protected getIdProperty() { return PrPointRedeemItemRow.idProperty; }
        protected getLocalTextPrefix() { return PrPointRedeemItemRow.localTextPrefix; }
        protected getNameProperty() { return PrPointRedeemItemRow.nameProperty; }
        protected getService() { return PrPointRedeemItemService.baseUrl; }
        protected getDeletePermission() { return PrPointRedeemItemRow.deletePermission; }
        protected getInsertPermission() { return PrPointRedeemItemRow.insertPermission; }
        protected getUpdatePermission() { return PrPointRedeemItemRow.updatePermission; }

        protected form = new PrPointRedeemItemForm(this.idPrefix);

    }
}